import React from 'react';
import theme from './EntityIcon.module.scss';
import EntityIcon, { ExternalEntityIconProps } from './EntityIcon';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { getProfileImageThumbnailUrl } from '@/services/profiles';
import { classnames } from '@/utils/html';

export type ProfileIconProps = ExternalEntityIconProps & {
    profileId: number | null | undefined;
};

const ProfileIcon = React.forwardRef<HTMLDivElement, ProfileIconProps>(
    ({ profileId, emptyIcon = faUsers as any, className, shape = 'square', fit = 'contain', ...rest }, ref) => {
        return (
            <EntityIcon
                ref={ref}
                url={profileId ? getProfileImageThumbnailUrl(profileId) : null}
                emptyIcon={emptyIcon}
                className={classnames(className, theme.profileImage)}
                shape={shape}
                fit={fit}
                {...rest}
            />
        );
    }
);

export default ProfileIcon;
